import { render, staticRenderFns } from "./BusinessPart.vue?vue&type=template&id=086e70f8&"
import script from "./BusinessPart.vue?vue&type=script&lang=js&"
export * from "./BusinessPart.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports